import http from "./http";

/**
 * Request OTP for phone number.
 * POST /api/v1/auth/end-user/otp/start
 */
export const requestOtp = async (phoneNumber) => {
  const response = await http.post("/auth/end-user/otp/start", {
    phoneNumber,
  });
  return response.data;
};

/**
 * Verify OTP and receive tokens + user context.
 * POST /api/v1/auth/end-user/otp/verify
 */
export const verifyOtp = async (phoneNumber, otp) => {
  const response = await http.post("/auth/end-user/otp/verify", {
    phoneNumber,
    otp,
  });
  return response.data;
};
